import { rem, SizedBox } from '@collabhouse/shared'
import React, { type FunctionComponent } from 'react'

const TopBarSpacer: FunctionComponent<React.PropsWithChildren<unknown>> = () => (
  <SizedBox height={{ desktop: rem(88), mobile: rem(64) }} />
)

export default TopBarSpacer
